<template>
  <div>
    <a-form @submit="submit" :data="data" ref="form" :form="form">
      <a-row class="form-row" :gutter="24">
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="创建人">
            <a-input :read-only="true" placeholder="创建人" v-decorator="[
          'creationUserName',
          {initialValue:data.creationUserName,rules: [{ required: false, message: '创建人' }]}]"></a-input>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="创建时间">
            <a-date-picker disabled showTime format="YYYY-MM-DD HH:mm:ss" placeholder="创建时间" v-decorator="[
          'creationTime',
          {initialValue:data.creationTime,rules: [{ required: false, message: '创建时间' }]}]"></a-date-picker>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="24">
          <a-form-item :labelCol="{
        xs: { span: 24 },
        sm: { span: 3 }
      }" :wrapperCol="{
        xs: { span: 24 },
        sm: { span: 21 }
      }" label="反馈内容">
            <a-textarea :read-only="true" :rows="6" placeholder="反馈内容" v-decorator="[
          'content',
          {initialValue:data.content,rules: [{ required: false, message: '反馈内容' }]}]"></a-textarea>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24" v-if="this.fileList.length>0">
        <a-col>
          <a-form-item label="附件" :labelCol="{
        xs: { span: 24 },
        sm: { span: 3 }
      }" :wrapperCol="{
        xs: { span: 24 },
        sm: { span: 21 }
      }">
            <div class="clearfix">
              <upload-image @uploadChange="uploadChange" :fileListInit="this.fileList" :imageCount="this.fileList.length" @cancelFile="cancelFile" :remove="false" :multiple="true" :showUploadList="{showPreviewIcon: true, showRemoveIcon: false }"></upload-image>
            </div>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row class="form-row" :gutter="24">
        <a-col :span="24">
          <a-form-item :labelCol="{
        xs: { span: 24 },
        sm: { span: 3 }
      }" :wrapperCol="{
        xs: { span: 24 },
        sm: { span: 21 }
      }" label="回复">
            <a-textarea :read-only="this.params.isShow" :rows="6" placeholder="请输入回复内容" v-decorator="[
          'replyContent',
          {initialValue:data.replyContent,rules: [{ required: true, message: '请输入回复内容' }]}]"></a-textarea>
          </a-form-item>
        </a-col>
      </a-row>
      <div v-if="!this.params.isShow" class="hp-manager-dialog-footer">
        <a-form-item label="">
          <a-button type="primary" @click="submit" :loading="loading">确认</a-button>
          <a-button style="margin-left:10px" @click="cancel">取消</a-button>
        </a-form-item>
      </div>
    </a-form>
  </div>
</template>

<script>
import moment from "moment";
import { api, exzends, rules } from "@/common";
import account from "@/mixins/account";
import dateFormat from "@/mixins/dateFormat";
import config from "@/config";
const defaultData = {
  id: 0,
  creationUserName: "",
  creationTime: null,
  hasReply: false
};
export default {
  name: "hp-manager-page-feedback-reply",
  mixins: [account, dateFormat],
  // 接受属性
  props: {
    params: Object
  },
  data() {
    return {
      loading: false,
      data: {},
      form: this.$form.createForm(this),
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      fileList: []
    };
  },

  async mounted() {
    await this.getDetailFeedback();
  },

  methods: {
    cancel() {
      this.$emit("cancel");
    },

    async getDetailFeedback() {
      this.loading = true;
      let result = await api.GetFeedback({ id: this.params.id });
      if (result) {
        this.data = result;
        this.data.creationTime = new moment(this.data.creationTime);
        if (result.pictureList) {
          let i = 1;
          result.pictureList.forEach(a => {
            this.fileList.push({
              uid: Math.random().toString(),
              name: i + "",
              status: "done",
              url: a
            });
            i++;
          });
          this.$emit("uploadChange", this.fileList);
        }
      }
      this.loading = false;
    },
    dataToPostData(value) {
      let result = {
        feedbackId: this.data.id,
        content: value.replyContent
      };
      return result;
    },
    //图片改变
    uploadChange(fileList) {
      this.fileList = fileList;
    },
    cancelFile(fileList) {
      this.fileList = fileList;
    },
    async submit() {
      this.loading = true;
      let valid = await new Promise((resolve, reject) => {
        this.form.validateFields((err, values) => {
          resolve({
            err,
            values,
            field: err ? "" : Object.keys(values)[0]
          });
        });
      });
      if (!valid.err) {
        let requestData = this.dataToPostData(valid.values);
        let data = await api.FeedbackReply(requestData);
        if (data) {
          this.$message.success("回复成功");
          this.$emit("submit-success");
        }
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
@import "../../../assets/scss/output.scss";
</style>



// WEBPACK FOOTER //
// src/router/Information/Feedback/Reply.vue